import { SkeletonRectangle, SkeletonGroup, Box, Text } from '@wix/design-system';
import SparklesGradient from '../../assets/images/SparklesGradient.svg?url';
import s from './DomainInsight.module.scss';
import React from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
export const DomainInsightSkeleton = _ref => {
  let {
    domain,
    compact
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    gap: "SP3",
    direction: "vertical",
    minHeight: compact ? undefined : '320px',
    minWidth: compact ? undefined : '347px',
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "3px",
    align: "left",
    verticalAlign: "middle",
    className: s.gradient
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("img", {
    src: SparklesGradient,
    alt: ""
  })), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, t('domain_search_suite.results.insight_widget.header'))), /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, domain && /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "bold"
  }, domain), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "298px",
    height: "14px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "276px",
    height: "14px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "243px",
    height: "14px"
  }))));
};
//# sourceMappingURL=DomainInsightSkeleton.js.map